// import html2pdf from "html2pdf.js";
// import { createContext, useContext, useState } from "react";


// const ResumeContext = createContext();

// const ResumeProvider = ({ children }) => {
//   const [activeSection, setActiveSection] = useState("Personal Details");

  


//   const [resumeData, setResumeData] = useState({
//     personalDetails: {
//       name: "",
//       phone: "",
//       email: "",
//       gender: "",
//       city: "",
//       jobTitle: "",
//       linkedin: "",
//       socialProfiles: [""],
//     },
//     skills: [],
//     skillFormat: "Linear",
//     experience: [
//       {
//         company: "",
//         jobTitle: "",
//         teamSize: "",
//         startDate: "",
//         endDate: "",
//         current: false,
//         fixedCTC: "",
//         variableCTC: "",
//         location: "",
//         industry: "",
//         responsibilities: "",
//       },
//     ],
//     projects: [{ title: "", link: "", description: "" }],
//     education: [{ college: "", gradYear: "", degree: "", description: "" }],
//     customSection: [{ title: "", description: "" }],
//   });

//   return (
//     <ResumeContext.Provider
//       value={{ resumeData, setResumeData, activeSection, setActiveSection}}
//     >
//       {children}
//     </ResumeContext.Provider>
//   );
// };

// const Sidebar = () => {
//   const { activeSection, setActiveSection } = useContext(ResumeContext);
//   const sections = [
//     "Personal Details",
//     "Experience",
//     "Projects",
//     "Education",
//     "Custom Section",
//   ];

//   return (
//     <div className="flex md:flex-col overflow-x-auto gap-4 border-b md:border-b-0 md:border-r p-4">
//       {sections.map((sec) => (
//         <button
//           key={sec}
//           onClick={() => setActiveSection(sec)}
//           className={`px-4 py-2 whitespace-nowrap rounded ${
//             activeSection === sec ? "bg-blue-600 text-white" : "bg-gray-100"
//           }`}
//         >
//           {sec}
//         </button>
//       ))}
//     </div>
//   );
// };




// const SectionEditor = () => {
//   const { activeSection, resumeData, setResumeData, setActiveSection } =
//     useContext(ResumeContext);

//   const handlePersonalChange = (field, value) => {
//     setResumeData((prev) => ({
//       ...prev,
//       personalDetails: { ...prev.personalDetails, [field]: value },
//     }));
//   };

// const fetchAISuggestions = async (title, idx) => {
//   const response = await fetch('/api/suggest-bullets', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ jobTitle: title }),
//   });
//   const data = await response.json();
//   const updated = [...resumeData.experience];
//   updated[idx].responsibilities = data.suggestions.join("\n");
//   setResumeData((prev) => ({ ...prev, experience: updated }));
// };


//   const handleSocialChange = (index, value) => {
//     const newProfiles = [...resumeData.personalDetails.socialProfiles];
//     newProfiles[index] = value;
//     setResumeData((prev) => ({
//       ...prev,
//       personalDetails: { ...prev.personalDetails, socialProfiles: newProfiles },
//     }));
//   };

//   const addSocialProfile = () => {
//     setResumeData((prev) => ({
//       ...prev,
//       personalDetails: {
//         ...prev.personalDetails,
//         socialProfiles: [...prev.personalDetails.socialProfiles, ""],
//       },
//     }));
//   };

//   const handleSkillChange = (index, field, value) => {
//     const updatedSkills = [...resumeData.skills];
//     updatedSkills[index][field] = value;
//     setResumeData((prev) => ({ ...prev, skills: updatedSkills }));
//   };

//   const addSkill = () => {
//     setResumeData((prev) => ({
//       ...prev,
//       skills: [...prev.skills, { name: "", proficiency: "" }],
//     }));
//   };

//   const handleExperienceChange = (index, field, value) => {
//     const updated = [...resumeData.experience];
//     updated[index][field] = value;
//     setResumeData((prev) => ({ ...prev, experience: updated }));
//   };

//   const addExperience = () => {
//     setResumeData((prev) => ({
//       ...prev,
//       experience: [
//         ...prev.experience,
//         {
//           company: "",
//           jobTitle: "",
//           teamSize: "",
//           startDate: "",
//           endDate: "",
//           current: false,
//           fixedCTC: "",
//           variableCTC: "",
//           location: "",
//           industry: "",
//           responsibilities: "",
//         },
//       ],
//     }));
//   };

//   const handleProjectChange = (index, field, value) => {
//     const updated = [...resumeData.projects];
//     updated[index][field] = value;
//     setResumeData((prev) => ({ ...prev, projects: updated }));
//   };

//   const addProject = () => {
//     setResumeData((prev) => ({
//       ...prev,
//       projects: [...prev.projects, { title: "", link: "", description: "" }],
//     }));
//   };

//   const handleEducationChange = (index, field, value) => {
//     const updated = [...resumeData.education];
//     updated[index][field] = value;
//     setResumeData((prev) => ({ ...prev, education: updated }));
//   };

//   const addEducation = () => {
//     setResumeData((prev) => ({
//       ...prev,
//       education: [
//         ...prev.education,
//         { college: "", gradYear: "", degree: "", description: "" },
//       ],
//     }));
//   };

//   const handleCustomSectionChange = (field, value) => {
//     setResumeData((prev) => ({
//       ...prev,
//       customSection: { ...prev.customSection, [field]: value },
//     }));
//   };

//   const getEditor = () => {
//     if (activeSection === "Personal Details") {
//       return (
//         <div className="flex flex-col gap-2">
//           <input
//             className="border p-2"
//             placeholder="Name"
//             value={resumeData.personalDetails.name}
//             onChange={(e) => handlePersonalChange("name", e.target.value)}
//           />
//           <input
//             className="border p-2"
//             placeholder="Contact Number"
//             value={resumeData.personalDetails.phone}
//             onChange={(e) => handlePersonalChange("phone", e.target.value)}
//           />
//           <input
//             className="border p-2"
//             placeholder="Email ID"
//             value={resumeData.personalDetails.email}
//             onChange={(e) => handlePersonalChange("email", e.target.value)}
//           />
//           <input
//             className="border p-2"
//             placeholder="Gender"
//             value={resumeData.personalDetails.gender}
//             onChange={(e) => handlePersonalChange("gender", e.target.value)}
//           />
//           <input
//             className="border p-2"
//             placeholder="City"
//             value={resumeData.personalDetails.city}
//             onChange={(e) => handlePersonalChange("city", e.target.value)}
//           />
//           <input
//             className="border p-2"
//             placeholder="Job Title"
//             value={resumeData.personalDetails.jobTitle}
//             onChange={(e) => handlePersonalChange("jobTitle", e.target.value)}
//           />
//           <input
//             className="border p-2"
//             placeholder="LinkedIn"
//             value={resumeData.personalDetails.linkedin}
//             onChange={(e) => handlePersonalChange("linkedin", e.target.value)}
//           />

//           <label className="font-semibold mt-2">Social Profiles</label>
//           {resumeData.personalDetails.socialProfiles.map((profile, idx) => (
//             <input
//               key={idx}
//               className="border p-2 my-1 w-full"
//               placeholder={`Profile ${idx + 1}`}
//               value={profile}
//               onChange={(e) => handleSocialChange(idx, e.target.value)}
//             />
//           ))}
//           <button onClick={addSocialProfile} className="text-blue-500 mt-1">
//             Add more social profiles
//           </button>

//           <label className="font-semibold mt-4">Skills Format:</label>
//           <select
//             className="border p-2 w-full"
//             value={resumeData.skillFormat}
//             onChange={(e) =>
//               setResumeData((prev) => ({
//                 ...prev,
//                 skillFormat: e.target.value,
//               }))
//             }
//           >
//             <option value="Linear">Linear (comma-separated)</option>
//             <option value="Categorised">
//               Categorised (languages, frameworks, DBs)
//             </option>
//           </select>

//           <div className="mt-2">
//             {resumeData.skills.map((skill, index) => (
//               <div key={index} className="flex gap-2 mb-2">
//                 <input
//                   className="border p-2 w-1/2"
//                   placeholder="Skill Name"
//                   value={skill.name}
//                   onChange={(e) =>
//                     handleSkillChange(index, "name", e.target.value)
//                   }
//                 />
//                 <input
//                   className="border p-2 w-1/2"
//                   placeholder="Proficiency (e.g. 1 yr 6 mo)"
//                   value={skill.proficiency}
//                   onChange={(e) =>
//                     handleSkillChange(index, "proficiency", e.target.value)
//                   }
//                 />
//               </div>
//             ))}
//             <button onClick={addSkill} className="text-blue-500">
//               Add more skills
//             </button>
//           </div>

//           <button
//             onClick={() => setActiveSection("Experience")}
//             className="mt-4 bg-blue-600 text-white px-4 py-2 rounded w-max"
//           >
//             Save and Next
//           </button>
//         </div>
//       );
//     }
//     if (activeSection === "Experience") {
//       return (
//         <div className="space-y-4">
//           {resumeData.experience.map((exp, idx) => (
//             <div key={idx} className="border p-4 rounded space-y-2">
//               <input
//                 className="w-full border p-2"
//                 placeholder="Company"
//                 value={exp.company}
//                 onChange={(e) =>
//                   handleExperienceChange(idx, "company", e.target.value)
//                 }
//               />
//               <input
//                 className="w-full border p-2"
//                 placeholder="Job Title"
//                 value={exp.jobTitle}
//                 onChange={(e) =>
//                   handleExperienceChange(idx, "jobTitle", e.target.value)
//                 }
//               />
//               <input
//                 className="w-full border p-2"
//                 placeholder="Team Size"
//                 value={exp.teamSize}
//                 onChange={(e) =>
//                   handleExperienceChange(idx, "teamSize", e.target.value)
//                 }
//               />
//               <input
//                 className="w-full border p-2"
//                 placeholder="Start Date"
//                 value={exp.startDate}
//                 onChange={(e) =>
//                   handleExperienceChange(idx, "startDate", e.target.value)
//                 }
//               />
//               <input
//                 className="w-full border p-2"
//                 placeholder="End Date"
//                 value={exp.endDate}
//                 onChange={(e) =>
//                   handleExperienceChange(idx, "endDate", e.target.value)
//                 }
//               />
//               <label className="flex items-center gap-2">
//                 <input
//                   type="checkbox"
//                   checked={exp.current}
//                   onChange={(e) =>
//                     handleExperienceChange(idx, "current", e.target.checked)
//                   }
//                 />
//                 I currently work here
//               </label>
//               <input
//                 className="w-full border p-2"
//                 placeholder="Fixed CTC (in LPA)"
//                 value={exp.fixedCTC}
//                 onChange={(e) =>
//                   handleExperienceChange(idx, "fixedCTC", e.target.value)
//                 }
//               />
//               <input
//                 className="w-full border p-2"
//                 placeholder="Variable CTC (in LPA)"
//                 value={exp.variableCTC}
//                 onChange={(e) =>
//                   handleExperienceChange(idx, "variableCTC", e.target.value)
//                 }
//               />
//               <input
//                 className="w-full border p-2"
//                 placeholder="Location"
//                 value={exp.location}
//                 onChange={(e) =>
//                   handleExperienceChange(idx, "location", e.target.value)
//                 }
//               />
//               <input
//                 className="w-full border p-2"
//                 placeholder="Industry"
//                 value={exp.industry}
//                 onChange={(e) =>
//                   handleExperienceChange(idx, "industry", e.target.value)
//                 }
//               />
//               <textarea
//                 className="w-full border p-2"
//                 placeholder="Roles and Responsibilities"
//                 value={exp.responsibilities}
//                 onChange={(e) =>
//                   handleExperienceChange(
//                     idx,
//                     "responsibilities",
//                     e.target.value
//                   )
//                 }
//                 rows={3}
//               />
//               <button
//                 onClick={() => fetchAISuggestions(exp.jobTitle, idx)}
//                 className="text-blue-500 text-sm mt-1"
//               >
//                 Get AI Suggestions
//               </button>
//             </div>
//           ))}
//           <div className="flex flex-col sm:flex-row justify-between gap-4">
//             <button onClick={addExperience} className="text-blue-600">
//               Add more past employers
//             </button>
//             <button
//               onClick={() => setActiveSection("Projects")}
//               className="bg-blue-600 text-white px-4 py-2 rounded w-max"
//             >
//               Save and Next
//             </button>
//           </div>
//         </div>
//       );
//     }

//     if (activeSection === "Projects") {
//       return (
//         <div className="space-y-4">
//           {resumeData.projects.map((proj, idx) => (
//             <div key={idx} className="border p-4 rounded space-y-2">
//               <input
//                 className="w-full border p-2"
//                 placeholder="Project Title"
//                 value={proj.title}
//                 onChange={(e) =>
//                   handleProjectChange(idx, "title", e.target.value)
//                 }
//               />
//               <input
//                 className="w-full border p-2"
//                 placeholder="Project Link (if any)"
//                 value={proj.link}
//                 onChange={(e) =>
//                   handleProjectChange(idx, "link", e.target.value)
//                 }
//               />
//               <textarea
//                 className="w-full border p-2"
//                 placeholder="Project Description"
//                 value={proj.description}
//                 onChange={(e) =>
//                   handleProjectChange(idx, "description", e.target.value)
//                 }
//                 rows={4}
//               />
//             </div>
//           ))}
//           <div className="flex flex-col sm:flex-row justify-between gap-4">
//             <button onClick={addProject} className="text-blue-600">
//               Add more projects
//             </button>
//             <button
//               onClick={() => setActiveSection("Education")}
//               className="bg-blue-600 text-white px-4 py-2 rounded w-max"
//             >
//               Save and Next
//             </button>
//           </div>
//         </div>
//       );
//     }

//     if (activeSection === "Education") {
//       return (
//         <div className="space-y-4">
//           {resumeData.education.map((edu, idx) => (
//             <div key={idx} className="border p-4 rounded space-y-2">
//               <input
//                 className="w-full border p-2"
//                 placeholder="College/University"
//                 value={edu.college}
//                 onChange={(e) =>
//                   handleEducationChange(idx, "college", e.target.value)
//                 }
//               />
//               <input
//                 className="w-full border p-2"
//                 placeholder="Graduation Year"
//                 value={edu.gradYear}
//                 onChange={(e) =>
//                   handleEducationChange(idx, "gradYear", e.target.value)
//                 }
//               />
//               <input
//                 className="w-full border p-2"
//                 placeholder="Degree in"
//                 value={edu.degree}
//                 onChange={(e) =>
//                   handleEducationChange(idx, "degree", e.target.value)
//                 }
//               />
//               <textarea
//                 className="w-full border p-2"
//                 rows={3}
//                 placeholder="Description (Optional)"
//                 value={edu.description}
//                 onChange={(e) =>
//                   handleEducationChange(idx, "description", e.target.value)
//                 }
//               />
//             </div>
//           ))}
//           <div className="flex flex-col sm:flex-row justify-between gap-4">
//             <button onClick={addEducation} className="text-blue-600">
//               Add more education
//             </button>
//             <button
//               onClick={() => setActiveSection("Custom Section")}
//               className="bg-blue-600 text-white px-4 py-2 rounded w-max"
//             >
//               Save and Next
//             </button>
//           </div>
//         </div>
//       );
//     }

//     if (activeSection === "Custom Section") {
//       return (
//         <div className="space-y-4">
//           <input
//             className="w-full border p-2"
//             placeholder="Section Name (e.g. Certifications, Publications)"
//             value={resumeData.customSection.title}
//             onChange={(e) => handleCustomSectionChange("title", e.target.value)}
//           />
//           <textarea
//             className="w-full border p-2"
//             rows={5}
//             placeholder="Description"
//             value={resumeData.customSection.description}
//             onChange={(e) =>
//               handleCustomSectionChange("description", e.target.value)
//             }
//           />
//           <button
//             onClick={() => setActiveSection("Personal Details")}
//             className="bg-blue-600 text-white px-4 py-2 rounded w-max"
//           >
//             Save and Next
//           </button>
//         </div>
//       );
//     }
//   };

//   return <div className="p-4">{getEditor()}</div>;
// };


// const Preview = ({ fontSize }) => {
//   const { resumeData } = useContext(ResumeContext);



//   return (
//     <div
//       id="resume-preview"
//       className="space-y-4"
//       style={{
//         userSelect: "none",
//         pointerEvents: "none",
//         padding: "96px",
//         fontFamily: "Arial, sans-serif",
//         fontSize:
//           fontSize === "small"
//             ? "11px"
//             : fontSize === "large"
//             ? "15px"
//             : "13px",
//         width: "794px",
//         minHeight: "1123px",
//         lineHeight: 1.5,
//         color: "#000",
//         backgroundColor: "#fff",
//         boxSizing: "border-box",
//       }}
//     >
   
//       <div>
//         <h1 className="font-bold">
//           {resumeData.personalDetails.name}
//         </h1>
//         <p>{resumeData.personalDetails.jobTitle}</p>
//         <p>
//           {resumeData.personalDetails.phone} | {resumeData.personalDetails.linkedin} | {resumeData.personalDetails.email}
//         </p>
//       </div>

//       {resumeData.skills.length > 0 && (
//         <div>
//           <h2 className="font-bold">SKILLS</h2>
//           <hr className="border-black mb-1" />
//           <p>
//             {resumeData.skills.map((s) => s.name).join(", ")}
//           </p>
//         </div>
//       )}

//       {resumeData.experience?.length > 0 && (
//         <div>
//           <h2 className="font-bold">EXPERIENCE</h2>
//           <hr className="border-black mb-1" />
//           {resumeData.experience.map((exp, idx) => (
//             <div key={idx} className="mb-2">
//               <p className="font-bold">
//                 {exp.jobTitle} <span className="font-normal">({exp.startDate} - {exp.current ? "Present" : exp.endDate})</span>
//               </p>
//               <p className="italic mb-1">{exp.company}</p>
//               <ul className="list-disc pl-5 leading-[1.4] space-y-1">
//                 {exp.responsibilities.split("\n").map((r, i) => (
//                   <li key={i}>{r}</li>
//                 ))}
//               </ul>
//             </div>
//           ))}
//         </div>
//       )}

//       {resumeData.projects?.length > 0 && (
//         <div>
//           <h2 className="font-bold">PROJECTS</h2>
//           <hr className="border-black mb-1" />
//           {resumeData.projects.map((proj, idx) => (
//             <div key={idx} className="mb-2">
//               <p className="font-bold">{proj.title}</p>
//               <ul className="list-disc pl-5 leading-[1.4] space-y-1">
//                 {proj.description.split("\n").map((r, i) => (
//                   <li key={i}>{r}</li>
//                 ))}
//               </ul>
//             </div>
//           ))}
//         </div>
//       )}

//       {resumeData.education?.length > 0 && (
//         <div>
//           <h2 className="font-bold">EDUCATION</h2>
//           <hr className="border-black mb-1" />
//           {resumeData.education.map((edu, idx) => (
//             <div key={idx}>
//               <p className="font-bold">
//                 {edu.college} {edu.gradYear && `(${edu.gradYear})`}
//               </p>
//               <p>{edu.degree}</p>
//               {edu.description && <p>{edu.description}</p>}
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };



// const exportToPDF = () => {
//   const element = document.getElementById("resume-preview");
//   html2pdf()
//     .set({
//       margin: 0,
//       filename: "resume.pdf",
//       image: { type: "jpeg", quality: 0.98 },
//       html2canvas: { scale: 2 },
//       jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
//       pagebreak: { mode: ["avoid-all", "css", "legacy"] },
//     })
//     .from(element)
//     .save();
// };

// const ResumeBuilderApp = () => {
//   const [fontSize, setFontSize] = useState("medium");
//   return (
//     <ResumeProvider>
//       <div className="grid md:grid-cols-[220px_1fr_1fr] grid-cols-1 min-h-screen">
//         <Sidebar />
//         <SectionEditor />

//         <div className="p-4 bg-gray-50 overflow-auto flex flex-col items-center">
//           <div className="mb-4 flex gap-2 items-center">
//             <label className="text-sm font-medium">Font Size:</label>
//             <select
//               value={fontSize}
//               onChange={(e) => setFontSize(e.target.value)}
//               className="border p-1 rounded"
//             >
//               <option value="small">Small</option>
//               <option value="medium">Medium</option>
//               <option value="large">Large</option>
//             </select>
//           </div>

//           <div
//             className="scale-[0.7] origin-top max-w-[794px] w-full shadow-xl border"
//             style={{ minHeight: "1123px" }}
//           >
//             <Preview fontSize={fontSize} />
//           </div>
//           <button
//             onClick={exportToPDF}
//             className="mt-4 bg-green-600 text-white px-4 py-2 rounded shadow"
//           >
//             Download PDF
//           </button>
//         </div>
//       </div>
//     </ResumeProvider>
//   );
// };
// export default ResumeBuilderApp;


import "../styles/ComingSoon.css";

const ResumeBuilderApp = () => {
  return (
    <div className="coming-soon-container">
      <div className="coming-soon-card">
        <h1>Resume Builder</h1>
        <p>Coming Soon...</p>
      </div>
    </div>
  );
};

export default ResumeBuilderApp;